<template>
  <v-app id="home">
    <v-app-bar
      app
      class="white elevation-0"
      height="200"
      absolute
    >
    <v-col class="d-flex flex-column" cols="12">
      <div class="d-flex justify-center mt-8" width="200">
        <v-btn href="/" width="190" height="65" class="white elevation-0">
          <v-img
            alt="Tasci Sigorta Logo"
            class="shrink"
            contain
            src="./assets/tasci-logo.png"
            transition="scale-transition"
            width="190"
            height="65"
          />
        </v-btn>
      </div>
      <div class="d-flex justify-center">
        <v-col cols="6">
         <v-divider class="black my-2"></v-divider>
        </v-col>
      </div>
      <div class="d-flex justify-center"> 
        <v-btn href="#Home" class="white elevation-0" x-small>
            Ana Sayfa
        </v-btn>
        <v-btn href="#services" class="white elevation-0" x-small>
            Hizmetler
        </v-btn>
        <v-btn href="#about" class="white elevation-0" x-small>
            Hakkında
        </v-btn>
        <v-btn href="#communication" class="white elevation-0" x-small>
            İletişim
        </v-btn>
      </div>
    </v-col>
    </v-app-bar>

    <v-main>
      <v-container>
    <v-row class="text-center">
      <v-col class="" cols="12">
        <h1 class="font-weight-light mt-4 welcome-header">
          TAŞÇI SİGORTA'ya
          <br>
          HOŞ GELDİNİZ
        </h1>

        <p class="font-weight-regular mt-10 welcome-text">
          Sigortacılıkta 28. yıl
        </p>
      </v-col>

      <v-col
        class="d-flex justify-center mb-8"
        cols="12"
      >
        <div class="mb-10 welcome-image">
          <v-img
            alt="Tasci Sigorta Logo"
            class="shrink"
            src="./assets/family_sunset.png"
            transition="scale-transition"
          />
        </div>
      </v-col>

      <v-col
        class="mt-8 mb-4"
        cols="12"
        id="services"
      >
        <div class="d-flex justify-center">
          <v-col class="" cols="8" lg="6">
            <h1 class="font-weight-light mb-10 float-left services-header">
              Hizmetlerimiz
            </h1>
            <p style="line-height: 2;" class="text-justify float-left services-text">
              Sağlık Sigortalarından Mesleki Sorumluluk sigortalarına, Ferdi Kaza sigortalarından Finansal Sigortalara kadar çok geniş
              yelpazede, bireysel ve kurumsal müşterilerimizin ihtiyaçlarına uygun tüm poliçeler ile hizmetinizdeyiz.
            </p>
          </v-col>
        </div>
      </v-col>

      <v-col
        class="mb-5 px-0 mx-0"
        cols="12"
      >
        <div class="grey d-flex flex-wrap justify-center lighten-1 py-16 mb-14">
          <v-card
            class="mx-2 my-3"
            max-width="270"
            min-height="500"
          >
            <v-img
              src="./assets/orman_araba.png"
              height="280px"
            ></v-img>

            <v-card-title class="font-weight-light">
              Kasko ve Trafik Sigortaları
            </v-card-title>

            <v-card-subtitle style="line-height: 2;" class="text-left black--text body-2 font-weight-light">
              Araçlarınızı ve üçüncü şahısları karşılaşabilecekleri  binbir riske karşı koruyan, mini onarım ve yardım hizmetleri ile hayatınızı kolaylaştıran sigortalar... 
            </v-card-subtitle>
          </v-card>
          <v-card
            class="mx-2 my-3"
            max-width="270"
            min-height="500"
          >
            <v-img
              src="./assets/sütünlar.png"
              height="280px"
            ></v-img>

            <v-card-title class="font-weight-light">
              Konut ve İşyeri Sigortaları
            </v-card-title>

            <v-card-subtitle style="line-height: 2;" class="text-left black--text body-2 font-weight-light">
              Hem varlıklarınızı her türlü riske karşı koruyacak hem de asistans hizmetleri ile hayatınızı kolaylaştıracak sigortalar...
            </v-card-subtitle>
          </v-card>
          <v-card
            class="mx-2 my-3"
            max-width="270"
            min-height="500"
          >
            <v-img
              src="./assets/yaprak.png"
              height="280px"
            ></v-img>

            <v-card-title class="font-weight-light">
              Sağlık Sigortaları
            </v-card-title>

            <v-card-subtitle style="line-height: 2;" class="text-left black--text body-2 font-weight-light">
              İsterseniz geniş kapsamlı Bireysel Sağlık ya da daha ekonomik olan Tamamlayıcı Sağlık, isterseniz yolculuklarınızın güvencesi Seyahat Sağlık...
            </v-card-subtitle>
          </v-card>
          <v-card
            class="mx-2 my-3"
            max-width="270"
            min-height="500"
          >
            <v-img
              src="./assets/bina_balkon.png"
              height="280px"
            ></v-img>

            <v-card-title class="font-weight-light">
              Mühendislik Sigortaları
            </v-card-title>

            <v-card-subtitle style="line-height: 2;" class="text-left black--text body-2 font-weight-light">
              İnşaat ve Montaj sigortalarından, Elektronik Cihaz sigortalarına kadar tüm riskleri kapsayan sigortalar...
            </v-card-subtitle>
          </v-card>
        </div>
      </v-col>
      
      <v-col cols="12" class="d-flex" id="about">
        <v-col cols="7" xs="" style="z-index: 9999;" class="mr-n16 left-padding">
          <v-row no-gutter align-content="center" class="mt-16">
            <div class="mt-16">
              <v-col cols="12" lg="5" xs="12" class="grey lighten-3 float-right pa-14">
                <h1 style="font-size:38px" class="font-weight-regular mb-6 float-left">
                  BİZ KİMİZ?
                </h1>
                <p style="font-size:14px; line-height: 2;" class="text-justify float-left mb-12">
                  1995 yılından bu yana, sektörün ileri gelen sigorta şirketleri aracılığı ve deneyimli ekibimizle, 
                  bireysel ve kurumsal sigortalılarımıza hizmet vermekteyiz.
                </p>
              </v-col>
            </div>
          </v-row>
        </v-col>
        <v-col cols="6" class="ml-n12 mb-16">
          <v-img
              class="shrink"
              src="./assets/ofis.png"
              transition="scale-transition"
              max-width="560"
            />
        </v-col>
      </v-col>

      <v-col cols="12" class="d-flex flex-wrap" id="communication">
        <v-col cols="12" lg="6" sm="12" class="margin-top">
          <v-col cols="12" lg="6" xs="12" class="d-flex flex-column float-right">
            <p style="font-size:38px" class="text-justify font-weight-regular float-left mb-6">
              BİZE ULAŞIN
            </p>
            <p style="font-size:14px ;line-height: 1.5;" class="text-justify float-left mb-8">
              Emek Mah. Barış Cad. Altılar Apt. No:5/B 01080 Seyhan Adana
            </p>
            <p style="font-size:14px;" class="text-justify float-left mb-8">
             tascisigorta1@gmail.com
            </p>
            <p style="font-size:14px;" class="text-justify float-left mb-2">
             0 (322) 436 55 21
            </p>
            <p style="font-size:14px;" class="text-justify float-left mb-2">
             0 (554) 748 55 85
            </p>
            <p style="font-size:14px;" class="text-justify float-left mb-8">
             0 (554) 748 54 63
            </p>
            <p style="font-size:14px;" class="text-justify float-left mb-2">
             Çalışma Saatleri:
            </p>
            <p style="font-size:14px;" class="text-justify float-left mb-2">
             Hafta içi: 09:00-18:00
            </p>
            <p style="font-size:14px;" class="text-justify float-left mb-2">
             Cumartesi: 09:00-13:00
            </p>
          </v-col>
        </v-col>
        <v-col cols="12" lg="6" sm="12" class="float-left margin-top margin-bot">
          <v-col cols="12" lg="6" xs="12" class="border">
            <template>
              <form ref="form" @submit.prevent="sendEmail">
                <label>İsim</label>
                <input type="text" name="from_name" id="from_name" required>
                <label>Telefon</label>
                <input type="text" name="phone" id="phone" required>
                <label>Konu</label>
                <input type="text" name="subject" id="subject" required>
                <label>Email</label>
                <input type="email" name="email" id="email" required>
                <label>Mesaj</label>
                <textarea name="message" id="message" required></textarea>
                <input type="submit" value="Gönder">
              </form>
            </template>
          </v-col>
        </v-col>
      </v-col>
    </v-row>
  </v-container>
    </v-main>
    <v-footer padless>
      <v-col
        style="font-size: 14px"
        class="white text-center font-weight-regular"
        cols="12"
      >
        <p>
          Taşçı Sigorta Ara. Hiz. Ltd. Şti. <br>
          Acente Levha Kayıt No: T08520-F271 
        </p>
        ©{{ new Date().getFullYear() }}, Taşçı Sigorta Ara. Hiz.
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import emailjs from '@emailjs/browser';

export default {
    name: 'Home',
    methods: {
      sendEmail(e) {
        try {
          emailjs.sendForm('service_ijycxn3', 'template_1cjrq37', e.target,'wePD1KI5cn8oKQkzx').then(() => {
            alert('Gönderildi!')
          })
          document.getElementById('from_name').value='';
          document.getElementById('email').value='';
          document.getElementById('phone').value='';
          document.getElementById('subject').value='';
          document.getElementById('message').value='';
        } catch (error) {
          console.log(error)
        }
      }
    }
  }
</script>

<style scoped>
  .welcome-header {
    font-size: 76px !important;
    line-height: normal;
  }
  .welcome-text {
    font-size: 20px !important;
  }
  .welcome-image {
    max-width: 940px;
  }
  .services-header {
    font-size: 76px !important;
  }
  .border {
    border: solid gray 1px
  }

  input {
    width: 100%;
    padding: 6px 8px;
    font-size: 14px;
    margin: 3px 0;
    display: inline-block;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
  }

  textarea {
    width: 100%;
    padding: 6px 8px;
    margin: 3px 0;
    font-size: 14px;
    display: inline-block;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
  }

  input[type=submit] {
    width: 100%;
    background-color: #000000;
    color: white;
    padding: 14px 20px;
    margin: 8px 0;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }

  input[type=submit]:hover {
    background-color: #2d2d2d;
  }

  label {
    float: left;
    font-weight: 300;
    font-size: 14px;
  }

  @media screen and (max-width: 900px) {
    .welcome-header {
      font-size: 36px !important;
    }
    .welcome-text {
      font-size: 14px !important;
    }
    .welcome-image {
      max-width: 300px;
    }
    .services-header {
      padding-left: 15px;
      font-size: 30px !important;
    }
    .services-text {
      font-size: 14px !important;
    }
    .left-padding {
      padding-left: 80px;
    }
    .margin-top {
      margin-top: 40px;
    }
    .margin-bot {
      margin-bottom: 40px;
    }
    input[type=submit]:hover {
    background-color: #2d2d2d;
  }
}
</style>
